<div>
  <div class="version">Ver {{version}}</div>
  <app-top-button [linkContents]="linkContents" [isSingle]="true"></app-top-button>
</div>